export default __webpack_public_path__ + "static/img/road-sign.ee34cb3.png";